export { Logotype } from "./logotype";
